export default "__VITE_ASSET__Ccc6ZLJP__"